/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RequestLocation,
    RequestLocationFromJSON,
    RequestLocationFromJSONTyped,
    RequestLocationToJSON,
} from './RequestLocation';

/**
 * 
 * @export
 * @interface ReceiveSettingsBulkUpdatePostRequest
 */
export interface ReceiveSettingsBulkUpdatePostRequest {
    /**
     * 受信設定で登録されているビジネスカテゴリ
     * @type {Array<number>}
     * @memberof ReceiveSettingsBulkUpdatePostRequest
     */
    businessCategories: Array<number>;
    /**
     * 受信設定で登録されているプレスリリース種類
     * @type {Array<string>}
     * @memberof ReceiveSettingsBulkUpdatePostRequest
     */
    pressReleaseTypes: Array<string>;
    /**
     * 受信設定で登録されている企業カテゴリ
     * @type {Array<string>}
     * @memberof ReceiveSettingsBulkUpdatePostRequest
     */
    companyCategories: Array<string>;
    /**
     * 受信設定で登録されている位置情報
     * @type {Array<RequestLocation>}
     * @memberof ReceiveSettingsBulkUpdatePostRequest
     */
    locations: Array<RequestLocation>;
    /**
     * 受信設定で登録されているキーワード
     * @type {Array<string>}
     * @memberof ReceiveSettingsBulkUpdatePostRequest
     */
    keywords: Array<string>;
}

export function ReceiveSettingsBulkUpdatePostRequestFromJSON(json: any): ReceiveSettingsBulkUpdatePostRequest {
    return ReceiveSettingsBulkUpdatePostRequestFromJSONTyped(json, false);
}

export function ReceiveSettingsBulkUpdatePostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiveSettingsBulkUpdatePostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'businessCategories': json['business_categories'],
        'pressReleaseTypes': json['press_release_types'],
        'companyCategories': json['company_categories'],
        'locations': ((json['locations'] as Array<any>).map(RequestLocationFromJSON)),
        'keywords': json['keywords'],
    };
}

export function ReceiveSettingsBulkUpdatePostRequestToJSON(value?: ReceiveSettingsBulkUpdatePostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'business_categories': value.businessCategories,
        'press_release_types': value.pressReleaseTypes,
        'company_categories': value.companyCategories,
        'locations': ((value.locations as Array<any>).map(RequestLocationToJSON)),
        'keywords': value.keywords,
    };
}

